export default "__VITE_ASSET__CYbgm2sd__"